<template>
  <MPopover
    :key="rendorCount"
    placement="bottomRight"
    :overlay-style="{ width: '300px' }"
    overlay-class-name="form-overlay"
    @show="handleShow"
  >
    <template v-slot:trigger>
      <MButton
        variant="transparent"
        class="text-neutral"
        :shadow="false"
        shape="circle"
      >
        <MTooltip placement="left">
          <template v-slot:trigger>
            <a>
              <MIcon
                class="text-neutral"
                name="bell"
                style="font-size: 1.5rem"
              />
            </a>
          </template>
          {{ $tc('notification') }} {{ $tc('setting', 2) }}
        </MTooltip>
      </MButton>
    </template>
    <h6>{{ $tc('notification') }} {{ $tc('setting', 2) }}</h6>
    <FlotoForm @submit="handleFormSubmit">
      <FlotoFormItem :label="$tc('enabled')">
        <MSwitch
          v-model="formData.enableMinQuantityNotification"
          size="small"
          class="mr-2"
        />
      </FlotoFormItem>
      <FlotoFormItem
        :label="`${$tc('minimum')} ${$tc('quantity')}`"
        :rules="minimumQuantityValidations"
      >
        <MInputGroup compact class="input-group-container">
          <div class="flex-1">
            <MInputNumber
              id="quanitity-input"
              v-model="formData.minQuantity"
              :precision="0"
              :placeholder="`${$tc('minimum')} ${$tc('quantity')}`"
            />
          </div>
          <MSelect
            v-model="formData.minQuantityType"
            :placeholder="$t('select')"
            :options="minQualntityTypeOptins"
            as-input
            :dropdown-match-select-width="false"
            :allow-clear="false"
            class="duration-type"
            input-classes="rounded-tl-none rounded-bl-none"
          >
          </MSelect>
        </MInputGroup>
      </FlotoFormItem>
      <template v-slot:submit>
        <div class="text-right">
          <MButton type="submit" :loading="porcessing">
            {{ $t('update') }}
          </MButton>
        </div>
      </template>
    </FlotoForm>
  </MPopover>
</template>

<script>
import { minQualntityTypeOptins } from '../helpers/option-map'
export default {
  name: 'QuantityNotificationBtn',
  props: {
    asset: { type: Object, required: true },
    updateApi: { type: Function, required: true },
  },
  data() {
    this.minQualntityTypeOptins = minQualntityTypeOptins()
    return {
      formData: {},
      porcessing: false,
      rendorCount: 1,
    }
  },
  computed: {
    minimumQuantityValidations() {
      const validations = {
        required: true,
        nonzero: true,
        ...(this.formData.minQuantityType === 'percentage'
          ? { min_value: 0, max_value: 100 }
          : { min_value: 0, max_value: true }),
      }
      return validations
    },
  },
  methods: {
    handleFormSubmit() {
      this.porcessing = true
      this.updateApi(this.formData)
        .then(() => {
          this.porcessing = false
          this.rendorCount = this.rendorCount + 1
        })
        .finally(() => {
          this.porcessing = false
        })
    },
    handleShow() {
      this.formData = {
        enableMinQuantityNotification: this.asset.enableMinQuantityNotification,
        minQuantityType: this.asset.minQuantityType || 'unit',
        minQuantity: this.asset.minQuantity,
      }
    },
  },
}
</script>
